/* eslint-disable react/prop-types */
import React, { createContext, useState } from 'react';

const StepperContext = createContext();

export const StepperProvider = ({ children }) => {
  const [step, setStep] = useState(1);

  const handleChangeStep = (stepNumber) => {
    setStep(stepNumber);
  };

  const data = { step, handleChangeStep };
  return <StepperContext.Provider value={data}>{children}</StepperContext.Provider>;
};

export default StepperContext;
